import styled from 'styled-components';

interface IProps {
  inverse?: boolean;
}

export const GraphContainer = styled.div<IProps>`
  background: ${(props: IProps): string =>
    props.inverse
      ? 'var(--color-list-background-inverse)'
      : 'var(--gradient-graph-background)'};
  height: 100%;
  width: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding-top: 20px;
  padding-bottom: 10px;
  cursor: pointer;
`;
